import React from 'react';
import { ReactComponent as GoogleIcon } from '../../images/google_btn_icon.svg';

/**
 * 
 * @param {*} param0 
 * @returns 
 * type: string//HTML5 button type. Defaults to submit.
 * onClick function // Callback function to run on click. Accepts parameter event.
 * params : any
 * buttonInnerIcon : string - you pass name of the icon and regarding this, call renderButtonInnerIcon
 * customClass: string //Class(es) to apply to the element.
 * btnText: string / text to display inside button.
 * transparent: Boolean
 * isBold: Boolean
 * textClassName string //Class(es) to apply to the element.
 * bordered: Boolean
 */

const ButtonComponent = ({
  type = 'submit',
  onClick,
  params,
  buttonInnerIcon,
  customClass,
  btnText,
  transparent = true,
  isBold = true,
  textClassName,
  bordered = false,
  disabled = false,
  isWhiteText = true
}) => {
  const renderButtonInnerIcon = icon => {
    if (icon === 'google') {
      return (
        <div className={'d-flex justify-content-center align-items-center google-icon-container '}>
          <GoogleIcon style={{ width: '19px', height: '19px' }} />
        </div>
      );
    }
  };

  const handleClick = (clickFunction, params) => {
    if (typeof clickFunction === 'function') {
      clickFunction(params);
    }
  };

  return (
    <button
      disabled={disabled}
      type={type}
      onClick={() => handleClick(onClick, params)}
      className={`d-flex justify-content-center align-items-center button-container border-radius-button ${customClass} 
      ${bordered ? 'button-bordered' : ''}`}
    >
      {buttonInnerIcon ? renderButtonInnerIcon(buttonInnerIcon) : null}
      <span
        className={`mx-1 button-text ${isBold ? 'font-weight-bold' : ''} ${!transparent ? 'text-dark' : '' } ${!isWhiteText ? 'text-white' : '' }  ${textClassName}`}
      >
        {btnText}
      </span>
    </button>
  );
};

export default ButtonComponent;
